export default {
    'driverPerformanceFunctionTab_escalation_escalation': "Escalación",
    'driverPerformanceFunctionTab_escalation_enableEscalation': "Habilitar Escalación",
    'driverPerformanceFunctionTab_escalation_escalationSteps': "Pasos de Escalación",
    'driverPerformanceFunctionTab_escalation_addStep': "Agregar>>",
    'driverPerformanceFunctionTab_escalation_removeStep': "Eliminar Paso",
    'driverPerformanceFunctionTab_escalation_step': "Paso",
    'driverPerformanceFunctionTab_escalation_maximumStepsReached': "Máximo 5 pasos permitidos",
    'driverPerformanceFunctionTab_escalation_escalationStepRequired': "Se requiere al menos un paso de escalación cuando la escalación está habilitada.",
    'driverPerformanceFunctionTab_escalation_labelTheValue': "< Etiqueta el Valor >",
    'driverPerformanceFunctionTab_escalation_labelLengthError': "La etiqueta debe tener entre 4 y 20 caracteres",
    'driverPerformanceFunctionTab_escalation_labelLengthTooltip': "Longitud: 4-20 caracteres",
    'driverPerformanceFunctionTab_escalation_save': "Guardar",
    'driverPerformanceFunctionTab_escalation_updatedConfiguration': "Configuración Guardada Correctamente",
    'driverPerformanceFunctionTab_escalation_updatedConfigurationError': "Error al Guardar la Configuración",
    'driverPerformanceFunctionTab_escalation_noStepsAdded': "Aún no se han agregado pasos de escalación",
}